// via https://developers.livechat.com/updates/setting-cookies-to-subdomains-in-javascript
export const setCookie = (name, value, daysToExpiration) => {
  let domain, domainParts, date, expires, host;

  if (daysToExpiration) {
    date = new Date();
    date.setTime(date.getTime() + daysToExpiration * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  host = window.location.host;

  // Remember the cookie on all subdomains.
  //
  // Start with trying to set cookie to the top domain.
  // (example: if user is on foo.com, try to set
  //  cookie to domain ".com")
  //
  // If the cookie will not be set, it means ".com"
  // is a top level domain and we need to
  // set the cookie to ".foo.com"
  domainParts = host.split('.');
  domainParts.shift();
  domain = '.' + domainParts.join('.');

  // Handles local development (ports) as well:
  window.document.cookie =
    name + '=' + value + expires + '; path=/; domain=' + domain.split(':')[0];

  // check if cookie was successfuly set to the given domain
  // (otherwise it was a Top-Level Domain)
  if (getCookie(name) === null || getCookie(name) !== value) {
    // append "." to current domain
    domain = '.' + host;
    window.document.cookie =
      name + '=' + value + expires + '; path=/; domain=' + domain;
  }
};

export const getCookie = (name) => {
  const nameEQ = name + '=';
  const ca = window.document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

export const eraseCookie = (name) => {
  setCookie(name, '', -1);
};
